import { ShieldCheck, Lock, RotateCcw, Truck } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Verified sellers only" },
  { icon: Lock, label: "Secure checkout" },
  { icon: RotateCcw, label: "Free returns on eligible items" },
  { icon: Truck, label: "Ships from the US" },
];

const TrustBar = () => (
  // Dark surface, matching the header/hero above and the brands band below so
  // the whole top of the page reads as one continuous dark region. `dark` scopes
  // the dark token set here too, so the muted icon/label colours re-resolve
  // light instead of staying light-theme grey on a dark ground.
  <div className="w-full fabric-texture fabric-texture-dark dark border-b border-border/50 h-auto py-2 md:h-[44px] md:py-0 flex items-center">
    <div className="w-full md:container md:mx-auto md:px-4 flex items-center md:justify-center overflow-x-auto md:overflow-visible scrollbar-hide md:divide-x md:divide-border/50 px-4 gap-x-5 md:gap-x-0 snap-x snap-mandatory md:snap-none">
      {items.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-1.5 md:px-6 flex-shrink-0 snap-start">
          <Icon size={14} className="text-muted-foreground opacity-60 flex-shrink-0" />
          <span className="text-[11px] font-medium text-muted-foreground whitespace-nowrap">{label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default TrustBar;
